module.exports = __webpack_public_path__ + "static/media/6.b1be7621.jpg";